/* Custom Package Protection row in Shrine's cart drawer.
   Safety rules from the "error while updating your cart" bug:
   - never touch the drawer while a cart request is in flight (busy flag)
   - only ever ADD our own node; never remove or reorder Shrine's nodes
   - re-place after Shrine re-renders the drawer (remove item, qty change),
     debounced so we never fight its render
*/
(function(){
var VARIANT=54511385968979;
var PRICE='2.99';
var busy=false;
var timer=null;

try{
var s=document.createElement('style');
s.textContent='cart-drawer [class*="upsell"],[id*="cart-drawer"] [class*="upsell"]{display:none !important;}';
document.head.appendChild(s);
}catch(e){}

function drawerEl(){
return document.querySelector('cart-drawer')||document.querySelector('#CartDrawer')||document.querySelector('[id*="cart-drawer"]');
}
function checkoutBtn(root){
return root.querySelector('[name="checkout"]')||root.querySelector('a[href*="/checkout"]')||root.querySelector('button[type="submit"]');
}

function row(on){
var d=document.createElement('div');
d.setAttribute('data-cd-protect','1');
d.setAttribute('style','display:flex !important; align-items:center; gap:12px; border:1.5px solid '+(on?'#0d2340':'#e5e0d3')+'; border-radius:12px; padding:12px 14px; margin:0 0 12px; background:'+(on?'#f6f2e6':'#fff')+'; cursor:pointer; font-family:Inter, sans-serif; text-align:left; width:100%; box-sizing:border-box;');
d.innerHTML=
'<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#0d2340" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;"><path d="M12 2 4 5.5v6c0 4.6 3.2 8.9 8 10.5 4.8-1.6 8-5.9 8-10.5v-6L12 2z"></path><path d="m9 12 2 2 4-4" stroke="#c9a227"></path></svg>'+
'<div style="flex:1; min-width:0;">'+
'<div style="font-weight:800; font-size:14px; color:#0d2340; line-height:1.3;">Package Protection <span style="color:#b1272f;">$'+PRICE+'</span></div>'+
'<div style="font-size:12px; color:#6b7385; line-height:1.4;">Lost, stolen, or eaten by the mailman? We ship a new pair free.</div>'+
'</div>'+
'<div style="width:22px; height:22px; border-radius:5px; flex-shrink:0; display:flex; align-items:center; justify-content:center; border:2px solid '+(on?'#b1272f':'#c4c9d4')+'; background:'+(on?'#b1272f':'#fff')+'; color:#fff; font-size:14px; font-weight:800; line-height:1;">'+(on?'&#10003;':'')+'</div>';
return d;
}

function reloadDrawer(){
var host=document.querySelector('[id^="shopify-section"][id*="cart-drawer"]');
if(!host){busy=false;schedule();return;}
var sid=host.id.replace('shopify-section-','');
fetch('/?sections='+encodeURIComponent(sid),{headers:{'Accept':'application/json'},credentials:'same-origin'})
.then(function(r){return r.json();})
.then(function(j){
var cur=drawerEl();
var fresh=new DOMParser().parseFromString(j[sid],'text/html').querySelector('cart-drawer');
if(cur&&fresh){cur.innerHTML=fresh.innerHTML;cur.classList.remove('is-empty');}
busy=false;
schedule();
})
.catch(function(){busy=false;schedule();});
}

function toggle(lineKey){
if(busy)return;
busy=true;
var req=lineKey
?fetch('/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:lineKey,quantity:0})})
:fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:VARIANT,quantity:1}]})});
req.then(reloadDrawer).catch(function(){busy=false;schedule();});
}

function place(){
if(busy)return;
var root=drawerEl();
if(!root||root.querySelector('[data-cd-protect]'))return;
if(!checkoutBtn(root))return;
fetch('/cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
.then(function(r){return r.json();})
.then(function(cart){
if(busy)return;
var r2=drawerEl();
if(!r2||!cart.items.length||r2.querySelector('[data-cd-protect]'))return;
var b=checkoutBtn(r2);
if(!b)return;
var line=null;
for(var i=0;i<cart.items.length;i++){if(cart.items[i].variant_id===VARIANT){line=cart.items[i];break;}}
var el=row(!!line);
el.addEventListener('click',function(ev){ev.preventDefault();ev.stopPropagation();toggle(line?line.key:null);});
var host=b.closest('form')||b.parentNode;
host.parentNode.insertBefore(el,host);
})
.catch(function(){});
}

/* debounced: Shrine replaces the drawer's innerHTML on every cart update,
   which wipes our row — put it back once its render has settled */
function schedule(){
clearTimeout(timer);
timer=setTimeout(place,320);
}

if(window.MutationObserver){
new MutationObserver(function(muts){
for(var i=0;i<muts.length;i++){
var t=muts[i].target;
if(t&&t.closest&&(t.closest('cart-drawer')||t.closest('[id*="cart-drawer"]'))){schedule();return;}
}
}).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
}
document.addEventListener('click',function(e){
if(e.target&&e.target.closest&&e.target.closest('#cd-add')){setTimeout(schedule,900);}
},true);
schedule();
})();
